export default __webpack_public_path__ + "1c8c6d83b26dc984742fb3eac420411a.woff";